export default __webpack_public_path__ + "static/media/VegFoliar.c9fd6429.png";